import React, { useEffect, useState } from "react";
import "./News.css";
import { dataNews } from "../../data-news";
import calendar from "../../assets/calendar.png";
import Pagination from "@mui/material/Pagination";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

function News() {
  const itemsPerPage = 9; // Number of items to display per page
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedType, setSelectedType] = useState("All"); // State to hold the selected type
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const [selectedType, setSelectedType] = useState(location.state?.selectedType || "All");
  useEffect(() => {
    // ฟังก์ชันตรวจสอบขนาดหน้าจอ
    const handleResize = () => {
      if (window.screen.width <= 1024) {
        setIsMobile(true); // ถ้าเป็นมือถือหรือขนาดเล็ก
      } else {
        setIsMobile(false); // ถ้าเป็นขนาดใหญ่
      }
    };

    // เรียกใช้เมื่อแสดงผลครั้งแรกและเวลาเปลี่ยนขนาดหน้าจอ
    handleResize();
    window.addEventListener("resize", handleResize);

    // ลบ event listener เมื่อ component ถูก unmount
    return () => window.removeEventListener("resize", handleResize);
  });

  const sortedData = [...dataNews].sort(
    (a, b) => new Date(b.id) - new Date(a.id)
  );
  // Filter the data based on the selected type
  const filteredItems =
    selectedType === "All"
      ? sortedData
      : sortedData.filter((item) => item.type === selectedType);

  // Calculate the items to display based on the current page

  // Calculate the items to display based on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const getTypeClass = (type) => {
    switch (type) {
      case "Blog":
        return "news-type blog";
      case "News":
        return "news-type news";
      case "Activity":
        return "news-type activity";
      default:
        return "news-type";
    }
  };
  const navigate = useNavigate();
  const handleCardClick = (id) => {
    navigate(`/detailNews/${id}`);
  };

  return (
    <>
      {!isMobile && (
        <div>
          <div className="header-news">
            <div className="text-header-news">{t("all_news_activity")}</div>
            <div className="text-sub-header">
              {t("news_activity_header")}
            </div>
          </div>
          <div className="content-news">
            <div className="tab-select">
            {["All", "News", "Activity", "Blog"].map((type) => (
                <div
                  key={type}
                  className={selectedType === type ? "box-active" : "box-inactive"}
                  onClick={() => {
                    setSelectedType(type); // ใช้ค่าที่เป็น key
                    setCurrentPage(1);
                  }}
                >
                  {t(`${type.toLowerCase()}`)}
                </div>
              ))}
            </div>
            <div className="news-cards">
              {currentItems.map((item) => (
                <div
                  className="main-card-annoument card-news"
                  key={item.id}
                  onClick={() => handleCardClick(item.id)}
                >
                  <img
                    src={item.image}
                    alt=""
                    className="main-image-news card-news"
                  />
                  <div className="content-text-annoument">
                    <div className="box-head-annoutment">
                      <div className={getTypeClass(item.type)}>{item.type.toUpperCase()}</div>
                      <div className="date">
                        <img
                          src={calendar}
                          alt="Calendar"
                          className="calendar"
                        />
                        <div className="text-date">{item.date}</div>
                      </div>
                    </div>
                    <div className="box-text-news">
                      <div className="box-text-head-news">{item.name}</div>
                      <div className="box-text-sub-news">
                        {item.description}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <Pagination
              count={Math.ceil(filteredItems.length / itemsPerPage)} // Adjust pagination based on filtered items
              page={currentPage}
              onChange={(event, page) => setCurrentPage(page)}
              color="primary"
              sx={{
                marginTop: 2,
                display: "flex",
                justifyContent: "center",
                "& .MuiPaginationItem-root": {
                  // Styles for the pagination items
                  width: "40px", // Width of each square
                  height: "40px", // Height of each square
                  borderRadius: "8px", // Optional: slightly rounded corners
                  margin: "0 4px", // Space between items
                  justifyContent: "center", // Center text inside the square
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold", // Optional: make the text bold
                },
                "& .Mui-selected": {
                  backgroundColor: "#485EDB", // Selected item color (adjust as needed)
                  color: "white", // Selected item text color
                },
                "& .MuiPaginationItem-ellipsis": {
                  display: "none", // Hide ellipsis if you want a cleaner look
                },
              }}
            />
          </div>
        </div>
      )}

      {isMobile && (
        <div>
          <div className="mobile-header-news">
            <div className="mobile-text-header-news">{t("all_news_activity")}</div>
            <div className="mobile-text-sub-header">
            {t("news_activity_header")}
            </div>
          </div>
          <div className="mobile-news-tags-container">
            <div className="mobile-content-news">
              <div className="mobile-tab-select">
                {["All", "News", "Activity", "Blog"].map((type) => (
                  <div
                    key={type}
                    className={
                      selectedType === type
                        ? "moile-box-active"
                        : "mobile-box-inactive"
                    }
                    onClick={() => {
                      setSelectedType(type);
                      setCurrentPage(1); // Reset to the first page whenever type changes
                    }}
                  >
                     {t(`${type.toLowerCase()}`)}
                  </div>
                ))}
              </div>
              <div className="mobile-news-cards">
                {currentItems.map((item) => (
                  <div
                    className="mobile-main-card-annoument mobile-card-news"
                    key={item.id}
                    onClick={() => handleCardClick(item.id)}
                  >
                    {/* <img src={item.Image} alt="" className="mobile-main-image-news mobile-card-news" /> */}
                    <div className="mobile-content-text-annoument">
                      <div className="mobile-box-head-annoutment">
                        <div className={getTypeClass(item.type)}>
                          {item.type}
                        </div>
                        <div className="date">
                          <img
                            src={calendar}
                            alt="Calendar"
                            className="calendar"
                          />
                          <div className="text-date">{item.date}</div>
                        </div>
                      </div>
                      <div className="mobile-box-text-news">
                        <div className="mobile-box-text-head-news">
                          {item.name}
                        </div>
                        <div className="mobile-box-text-sub-news">
                          {item.description}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <Pagination
                count={Math.ceil(filteredItems.length / itemsPerPage)} // Adjust pagination based on filtered items
                page={currentPage}
                onChange={(event, page) => setCurrentPage(page)}
                color="primary"
                sx={{
                  marginTop: 2,
                  display: "flex",
                  justifyContent: "center",
                  marginLeft: "45px", 
                  "& .MuiPaginationItem-root": {
                    // Styles for the pagination items
                    width: "40px", // Width of each square
                    height: "40px", // Height of each square
                    borderRadius: "8px", // Optional: slightly rounded corners
                    margin: "0 4px", // Space between items
                    justifyContent: "center", // Center text inside the square
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "bold", // Optional: make the text bold
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#485EDB", // Selected item color (adjust as needed)
                    color: "white", // Selected item text color
                  },
                  "& .MuiPaginationItem-ellipsis": {
                    display: "none", // Hide ellipsis if you want a cleaner look
                  },
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default News;

